import { render } from "./mga-report-list.vue?vue&type=template&id=e48978d4&ts=true"
import script from "./mga-report-list.ts?vue&type=script&lang=ts"
export * from "./mga-report-list.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__